import React, { Component } from "react";
import { connect } from "react-redux";

import { Post } from "utils/axios";
import { requestError, requestSuccess } from "utils/requestHandler";

const HOC = (WrappedComponent) => {
	class WithHOC extends Component {
		state = {
			loading: false,
		};

		onChangeSampleHOC = (key, val) => this.setState({ [key]: val });

		load = (param) => this.setState({ loading: param });

		createAssets = (dataToSubmit, callback) =>
			Post(
				`/assets`,
				dataToSubmit,
				(val) => this.createAssetsSuccess(val, callback),
				this.createAssetsError,
				this.load
			);
		createAssetsSuccess = (payload, callback) => {
			console.log(payload);
			callback(payload.data.url);
			// requestSuccess("Record has been created successfully.");
		};
		createAssetsError = (error) => requestError(error);

		render = () => {
			return (
				<WrappedComponent
					{...this.props}
					createAssets={this.createAssets}
					onLoadAsset={this.state.loading}
				/>
			);
		};
	}
	const mapStateToProps = (state) => ({ data: state });
	return connect(mapStateToProps)(WithHOC);
};

export default HOC;
